/**
 * @auth 赖传峰
 * @date 2022/5/10
 */
import { computed, useRequestHeaders } from '#imports'
import { getDomain } from '~/utils'

// 二级域名、三级域名
const URL_REG = /^(?:[-\w]+\.)?(\w+\.\w+)$/

export default () =>
  computed(() => {
    const severHost = useRequestHeaders(['host']).host || ''

    // 如果 severHost 为空，则使用 clientHost
    return URL_REG.test(severHost) ? severHost.replace(URL_REG, '$1') : getDomain()
  })
